export { default as Home } from './Home';
export { default as MyFiles } from './MyFiles';
export { default as Notifications } from './Notifications';
export { default as DistributionShare } from './Distribution-Share';
export { default as Settings } from './Settings';


// WEBPACK FOOTER //
// ./src/components/routes/index.js